<template>
  <div>
    <div class="large-empty no-patient" v-show="!selectedPatient.length">
      <i class="fa fa-info-circle fa-3x"></i>
      <span>
        Hasta detaylarını görmek için Hasta Listesinden hasta seçmelisiniz
      </span>
    </div>
    <div class="h-bar short" v-if="selectedPatient.length">
      <div class="name">
        {{ selectedPatient[0].name }}
      </div>
      <div class="kan-grubu">
        <span class="anne">
          <span class="c-blue">Anne :</span>
          {{
            selectedPatient[0].annekan == "" ? "-" : selectedPatient[0].annekan
          }}
        </span>
        <span class="bebek">
          {{ selectedPatient[0].kan == "" ? "-" : selectedPatient[0].kan }}
        </span>
        <span class="coombs" :class="coombs_color()">
          {{ selectedPatient[0].coombs }}
        </span>
      </div>
      <div class="completed">
        <Progress
          :strokeColor="completed[1]"
          :strokeWidth="4"
          :radius="28"
          :value="completed[0]"
        >
          <div class="content" :class="'c-' + completed[1]">
            {{ completed[0] }}
          </div>
        </Progress>
      </div>
      <div class="tabs">
        <ul>
          <li
            @click.prevent="setTabActive(1)"
            :class="{ active: isTabActive(1) }"
          >
            Hasta Dosyası
          </li>
          <li
            @click.prevent="setTabActive(2)"
            :class="{ active: isTabActive(2) }"
          >
            Epikriz
          </li>
          <li
            id="yazdir-tab"
            @click.prevent="setTabActive(3)"
            :class="{ active: isTabActive(3) }"
          >
            Yazdır
          </li>
        </ul>
      </div>
    </div>
    <div id="content" class="servis-content" v-if="selectedPatient.length">
      <div id="tab-1" class="tab-content" v-show="isTabActive(1)">
        <div class="patient-profile card-40">
          <div class="patient-header">
            <div class="sex">
              <span class="bg-blue" v-show="selectedPatient[0].sex == 1">
                <i class="fa fa-lg fa-male"></i>
              </span>
              <span class="bg-pink" v-show="selectedPatient[0].sex == 2">
                <i class="fa fa-lg fa-female"></i>
              </span>
            </div>
            <div class="btn-group">
              <a v-show="isYatis" class="btn link-blue" @click="editYatis()">
                <i class="fa fa fa-edit"></i>
                Düzenle
              </a>
              <a
                class="btn link-red fr"
                v-show="isYatis && user.level == 1"
                @click.prevent="taburcu()"
              >
                <i class="fa fa fa-sign-out-alt"></i>
                Taburcu Et
              </a>
              <a
                class="btn link-red fr"
                v-show="!isYatis && user.level == 1"
                @click.prevent="removePatient()"
              >
                <i class="fa fa fa-trash"></i>
                Kaldır
              </a>
              <a
                class="btn link-blue"
                v-show="!isYatis && user.level == 1"
                @click.prevent="undotaburcu()"
              >
                <i class="fa fa fa-undo"></i>
                Geri Al
              </a>
            </div>
            <div class="name">
              {{ selectedPatient[0].name }}
            </div>
            <div class="age">
              {{ selectedPatient[0].birth | toYDGun }}
            </div>

            <ul class="bulgular">
              <li class="info bordered">
                <span class="title">GH</span>
                <span class="value">{{ gh }}</span>
              </li>
              <li class="info bordered">
                <span class="title">Doğum</span>
                <span class="value"> {{ selectedPatient[0].dtarti }} gr </span>
              </li>
              <li class="info">
                <span class="title">Yatış</span>
                <span class="value"> {{ selectedPatient[0].ytarti }} gr </span>
                <span class="persantil">{{ tarti_fark }}</span>
              </li>
            </ul>
            <div class="details">
              <div class="tanilar">
                <div class="gun">
                  <p>
                    <b> {{ selectedPatient[0].yatis | toOnlyGun }}. </b>
                  </p>
                  <p>GÜN</p>
                </div>
                <span v-show="selectedPatient[0].tanilar != ''">
                  {{ selectedPatient[0].tanilar }}
                </span>
                <span class="c-red" v-show="selectedPatient[0].tanilar == ''">
                  <i class="fa fa-exclamation-triangle"></i>
                  Tanı Girilmemiş
                </span>
              </div>
            </div>
          </div>

          <div class="y-special-data">
            <ul class="patient-infos">
              <li class="info">
                <div class="info-header">
                  <span class="title">ÖZGEÇMİŞ</span>
                  <a
                    class="btn link-blue"
                    v-show="
                      selectedPatient[0].ozgecmis != '' && !ozgecmis.editing
                    "
                    @click="editOzgecmis()"
                  >
                    <i class="fa fa fa-edit"></i>
                    Düzenle
                  </a>
                </div>
                <div
                  v-show="
                    selectedPatient[0].ozgecmis == '' && !ozgecmis.editing
                  "
                  class="small-empty"
                >
                  <i class="fa fa-info-circle fa-3x"></i>
                  <span>
                    Yazmak için
                    <a class="c-red" @click="editOzgecmis('sablon')">
                      tıklayın
                    </a>
                  </span>
                </div>
                <span
                  class="value"
                  v-show="
                    selectedPatient[0].ozgecmis != '' && !ozgecmis.editing
                  "
                >
                  {{ selectedPatient[0].ozgecmis }}
                </span>
                <div class="edit-form" v-if="ozgecmis.editing">
                  <form class="editing-form" v-on:submit.prevent>
                    <div class="labeledit">
                      <textarea-autosize
                        id="p-ozgecmis"
                        rows="4"
                        spellcheck="false"
                        v-model="ozgecmis.value"
                      />
                    </div>
                  </form>
                  <div class="btn-bar">
                    <a class="btn btn-green" @click="saveOzgecmis()">
                      <i class="fa fa fa-check"></i>
                      Kaydet
                    </a>
                    <a class="btn link-red" @click="ozgecmis.editing = false">
                      <i class="fa fa fa-times"></i>
                      İptal
                    </a>
                  </div>
                </div>
              </li>
              <li class="info">
                <div class="info-header">
                  <span class="title">SOYGEÇMİŞ</span>
                  <a
                    class="btn link-blue"
                    v-show="
                      selectedPatient[0].soygecmis != '' && !soygecmis.editing
                    "
                    @click="editSoygecmis()"
                  >
                    <i class="fa fa fa-edit"></i>
                    Düzenle
                  </a>
                </div>
                <div
                  v-show="
                    selectedPatient[0].soygecmis == '' && !soygecmis.editing
                  "
                  class="small-empty"
                >
                  <i class="fa fa-info-circle fa-3x"></i>
                  <span>
                    Yazmak için
                    <a class="c-red" @click="editSoygecmis('sablon')">
                      tıklayın
                    </a>
                  </span>
                </div>
                <span
                  class="value"
                  v-show="
                    selectedPatient[0].soygecmis != '' && !soygecmis.editing
                  "
                >
                  {{ selectedPatient[0].soygecmis }}
                </span>
                <div class="edit-form" v-if="soygecmis.editing">
                  <form class="editing-form" v-on:submit.prevent>
                    <div class="labeledit">
                      <textarea-autosize
                        id="p-soygecmis"
                        rows="4"
                        spellcheck="false"
                        v-model="soygecmis.value"
                      />
                    </div>
                  </form>
                  <div class="btn-bar">
                    <a class="btn btn-green" @click="saveSoygecmis()">
                      <i class="fa fa fa-check"></i>
                      Kaydet
                    </a>
                    <a class="btn link-red" @click="soygecmis.editing = false">
                      <i class="fa fa fa-times"></i>
                      İptal
                    </a>
                  </div>
                </div>
              </li>
              <li class="info">
                <div class="info-header">
                  <span class="title">MUAYENE</span>
                  <a
                    class="btn link-blue"
                    v-show="
                      selectedPatient[0].muayene != '' && !muayene.editing
                    "
                    @click="editMuayene()"
                  >
                    <i class="fa fa fa-edit"></i>
                    Düzenle
                  </a>
                </div>
                <div
                  v-show="selectedPatient[0].muayene == '' && !muayene.editing"
                  class="small-empty"
                >
                  <i class="fa fa-info-circle fa-3x"></i>
                  <span>
                    Yazmak için
                    <a class="c-red" @click="editMuayene('sablon')">
                      tıklayın
                    </a>
                  </span>
                </div>
                <span
                  class="value"
                  v-show="selectedPatient[0].muayene != '' && !muayene.editing"
                >
                  {{ selectedPatient[0].muayene }}
                </span>
                <div class="edit-form" v-if="muayene.editing">
                  <form class="editing-form" v-on:submit.prevent>
                    <div class="labeledit">
                      <textarea-autosize
                        id="p-muayene"
                        rows="4"
                        spellcheck="false"
                        v-model="muayene.value"
                      />
                    </div>
                  </form>
                  <div class="btn-bar">
                    <a class="btn btn-green" @click="saveMuayene()">
                      <i class="fa fa fa-check"></i>
                      Kaydet
                    </a>
                    <a class="btn link-red" @click="muayene.editing = false">
                      <i class="fa fa fa-times"></i>
                      İptal
                    </a>
                  </div>
                </div>
              </li>
            </ul>
          </div>

          <transition name="fade">
            <div class="modal-overlay" v-if="editingYatis">
              <div class="modal-box small">
                <span class="close" @click="cancelYatis()">
                  &times;
                </span>
                <h3>Düzenle</h3>
                <form v-on:submit.prevent autocomplete="off">
                  <div class="labeledit">
                    <label for="p-tanilar">Tanılar</label>
                    <input
                      type="text"
                      v-model="selectedPatient[0].tanilar"
                      id="p-tanilar"
                    />
                  </div>
                  <div class="labeledit">
                    <label for="p-dosya">Dosya No</label>
                    <input
                      type="number"
                      v-model.number="selectedPatient[0].dosya"
                      id="p-dosya"
                    />
                  </div>
                  <div class="labeledit">
                    <label for="p-adi">Adı Soyadı</label>
                    <input
                      type="text"
                      v-model="selectedPatient[0].name"
                      id="p-adi"
                    />
                  </div>
                  <div class="labeledit">
                    <label>Cinsiyet</label>

                    <div class="toggle-group">
                      <label class="selam" for="p-cinsiyet-1">
                        <input
                          id="p-cinsiyet-1"
                          type="radio"
                          value="1"
                          class="modern"
                          v-model="selectedPatient[0].sex"
                        />
                        <span>Erkek</span>
                      </label>

                      <label class="selam" for="p-cinsiyet-2">
                        <input
                          id="p-cinsiyet-2"
                          type="radio"
                          value="2"
                          class="modern"
                          v-model="selectedPatient[0].sex"
                        />
                        <span>Kız</span>
                      </label>
                    </div>
                  </div>
                  <div class="labeledit">
                    <label for="p-dogum">
                      Doğum Tarihi
                    </label>
                    <input
                      type="datetime-local"
                      v-model="selectedPatient[0].birthv2"
                      id="p-dogum"
                    />
                  </div>
                  <div class="labeledit">
                    <label for="p-yatis">
                      Yatış Tarihi
                    </label>
                    <input
                      type="date"
                      v-model="selectedPatient[0].yatis"
                      id="p-yatis"
                    />
                  </div>
                  <div class="labeledit">
                    <label for="p-week">
                      Gestasyonel Hafta
                    </label>
                    <div class="multi-input">
                      <input
                        type="number"
                        placeholder="34 haftalıksa 34 yazın"
                        id="p-week"
                        v-model="selectedPatient[0].dhafta"
                      />
                      <div class="space"></div>
                      <input
                        type="number"
                        placeholder="0-6 arası gün yazın"
                        id="p-day"
                        v-model="selectedPatient[0].dgun"
                      />
                    </div>
                  </div>
                  <div class="labeledit">
                    <label for="p-dtarti">
                      Doğum Tartısı (gr)
                    </label>
                    <input
                      type="number"
                      v-model.number="selectedPatient[0].dtarti"
                      id="p-dtarti"
                    />
                  </div>
                  <div class="labeledit">
                    <label for="p-ytarti">
                      Yatış Tartısı (gr)
                    </label>
                    <input
                      type="number"
                      v-model.number="selectedPatient[0].ytarti"
                      id="p-ytarti"
                    />
                  </div>
                  <div class="labeledit">
                    <label for="p-boy">Boy (cm)</label>
                    <input
                      type="number"
                      v-model.number="selectedPatient[0].boy"
                      id="p-boy"
                    />
                  </div>
                  <div class="labeledit">
                    <label for="p-basc">
                      Baş Çevresi (cm)
                    </label>
                    <input
                      type="number"
                      v-model.number="selectedPatient[0].basc"
                      id="p-basc"
                    />
                  </div>
                  <div class="labeledit">
                    <label for="p-mommykan">
                      Anne Kan Grubu
                    </label>
                    <select
                      id="p-mommykan"
                      v-model="selectedPatient[0].annekan"
                    >
                      <option value>(Belli Değil)</option>
                      <option value="0 Rh(+)">
                        0 Rh(+)
                      </option>
                      <option value="A Rh(+)">
                        A Rh(+)
                      </option>
                      <option value="B Rh(+)">
                        B Rh(+)
                      </option>
                      <option value="AB Rh(+)">
                        AB Rh(+)
                      </option>
                      <option value="0 Rh(-)">
                        0 Rh(-)
                      </option>
                      <option value="A Rh(-)">
                        A Rh(-)
                      </option>
                      <option value="B Rh(-)">
                        B Rh(-)
                      </option>
                      <option value="AB Rh(-)">
                        AB Rh(-)
                      </option>
                    </select>
                  </div>
                  <div class="labeledit">
                    <label for="p-babykan">
                      Bebek Kan Grubu
                    </label>
                    <select id="p-babykan" v-model="selectedPatient[0].kan">
                      <option value>(Belli Değil)</option>
                      <option value="0 Rh (+)">
                        0 Rh (+)
                      </option>
                      <option value="A Rh (+)">
                        A Rh (+)
                      </option>
                      <option value="B Rh (+)">
                        B Rh (+)
                      </option>
                      <option value="AB Rh (+)">
                        AB Rh (+)
                      </option>
                      <option value="0 Rh (-)">
                        0 Rh (-)
                      </option>
                      <option value="A Rh (-)">
                        A Rh (-)
                      </option>
                      <option value="B Rh (-)">
                        B Rh (-)
                      </option>
                      <option value="AB Rh (-)">
                        AB Rh (-)
                      </option>
                    </select>
                  </div>
                  <div class="labeledit">
                    <label for="p-babycoombs">
                      Bebek D.Coombs
                    </label>
                    <select
                      id="p-babycoombs"
                      v-model="selectedPatient[0].coombs"
                    >
                      <option value>(Belli Değil)</option>
                      <option value="D.Coombs (-)">
                        D.Coombs (-)
                      </option>
                      <option value="D.Coombs (-+)">
                        D.Coombs (-+)
                      </option>
                      <option value="D.Coombs (+)">
                        D.Coombs (+)
                      </option>
                      <option value="D.Coombs (++)">
                        D.Coombs (++)
                      </option>
                      <option value="D.Coombs (+++)">
                        D.Coombs (+++)
                      </option>
                      <option value="D.Coombs (++++)">
                        D.Coombs (++++)
                      </option>
                    </select>
                  </div>
                </form>
                <div class="button-bar">
                  <a class="btn link-green fr" @click.prevent="saveYatis()">
                    <i class="fa fa fa-save"></i>
                    Kaydet
                  </a>
                  <div class="clear"></div>
                </div>
              </div>
            </div>
          </transition>
        </div>

        <div class="patient-profile card-60">
          <div class="y-not-data" v-if="selectedPatient.length">
            <transition name="fade">
              <div class="modal-overlay" v-if="editingNot">
                <div class="modal-box medium">
                  <span class="close" @click="cancelNot()">
                    &times;
                  </span>
                  <h3>Düzenle</h3>
                  <form v-on:submit.prevent autocomplete="off">
                    <div class="labeledit">
                      <label for="p-notyatis">
                        Yatış Tarihi
                      </label>
                      <input
                        type="date"
                        v-model="selectedPatient[0].yatis"
                        id="p-notyatis"
                      />
                    </div>
                    <div class="labeledit vertical">
                      <label for="p-oyku">Öykü</label>
                    </div>
                    <div class="labeledit">
                      <textarea-autosize
                        id="p-oyku"
                        spellcheck="false"
                        rows="6"
                        v-model="selectedPatient[0].oyku"
                      />
                    </div>
                    <div class="labeledit vertical">
                      <label for="p-ynot">
                        Yatış Notu
                      </label>
                    </div>
                    <div class="labeledit">
                      <textarea-autosize
                        id="p-ynot"
                        spellcheck="false"
                        rows="10"
                        v-model="selectedPatient[0].ynot"
                      />
                    </div>
                    <div class="labeledit vertical">
                      <label for="p-snap">Skorlama</label>
                    </div>
                    <div class="labeledit">
                      <textarea-autosize
                        id="p-snap"
                        spellcheck="false"
                        rows="5"
                        v-model="selectedPatient[0].snap"
                      />
                    </div>
                    <div class="labeledit vertical">
                      <label for="p-dr">
                        Yatıran Doktor
                      </label>
                      <select id="p-dr" v-model="selectedPatient[0].dr">
                        <option :value="0">
                          (Yok)
                        </option>
                        <option
                          :value="d.id"
                          v-for="d in activedoctors"
                          :key="d.id"
                        >
                          Dr.{{ d.name }}
                        </option>
                      </select>
                    </div>
                  </form>
                  <div class="button-bar">
                    <a class="btn link-green fr" @click.prevent="saveNot()">
                      <i class="fa fa fa-check"></i>
                      Kaydet
                    </a>
                    <div class="clear"></div>
                  </div>
                </div>
              </div>
            </transition>
            <div class="info-header">
              <a
                class="btn link-indigo"
                v-show="!editingNot"
                @click.prevent="printYatisNotu()"
              >
                <i class="fa fa fa-print"></i>
                Yazdır
              </a>
              <a
                class="btn link-blue"
                v-show="isYatis && !editingNot && user.level == 1"
                @click="editNot()"
              >
                <i class="fa fa fa-edit"></i>
                Düzenle
              </a>
            </div>
            <div class="y-not" v-if="!editingNot" id="printYatisNotu">
              <p>
                <center>
                  <b>YATIŞ NOTU</b>
                </center>
              </p>
              <p style="text-align: right">
                <b>
                  {{ selectedPatient[0].yatis | moment("DD.MM.YYYY") }}
                </b>
              </p>
              <p class="invisible">
                <b>{{ selectedPatient[0].name }}</b>
              </p>
              <p>{{ selectedPatient[0].oyku }}</p>
              <p>{{ selectedPatient[0].ynot }}</p>
              <p>{{ selectedPatient[0].snap }}</p>
              <p style="text-align: right">
                <b>
                  {{ selectedPatient[0].dr > 0 ? "Dr." + yatirandr_name : "" }}
                </b>
              </p>
            </div>
          </div>
          <div class="snap-warning" v-if="selectedPatient[0].snap == ''">
            <div class="box c-red">
              <div class="icon">
                <i class="fa fa-2x fa-exclamation"></i>
              </div>
              <div class="title">SNAP Skoru girilmemiş</div>
            </div>
            <div class="form">
              <div class="labeledit">
                <label for="p-snap">SNAP Skorlama</label>
                <div class="multi-input">
                  <input
                    type="number"
                    placeholder="SNAP II"
                    class="c-input"
                    id="p-snap"
                    v-model="snap"
                  />
                  <div class="space"></div>
                  <input
                    type="number"
                    class="c-input"
                    placeholder="SNAP-PE II"
                    id="p-snappe"
                    v-model="snappe"
                  />
                </div>
              </div>
              <div class="fr">
                <button class="btn btn-blue fr" @click.prevent="skorla()">
                  Kaydet
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="card card-40" v-if="isYatis && user.level == 1">
          <p class="header bg-blue">Tedavi Planı</p>
          <ul class="tedavi-tabs">
            <li
              @click.prevent="setTedaviTabActive(1)"
              :class="{ active: isTedaviTabActive(1) }"
            >
              Öneriler
            </li>
            <li
              @click.prevent="setTedaviTabActive(2)"
              :class="{ active: isTedaviTabActive(2) }"
            >
              Mayiler
            </li>
          </ul>
          <div class="y-tedavi-plan">
            <div class="col" v-show="isTedaviTabActive(1)">
              <transition name="slide-fade" mode="out-in">
                <ul class="ilaclar" v-if="aktifIlac == 0">
                  <li>
                    <a class="btn link-green" @click.prevent="getIlac(1)">
                      <span>AMPİSİLİN</span>
                      <i class="fa fa fa-chevron-right"></i>
                    </a>
                  </li>
                  <li>
                    <a class="btn link-green" @click.prevent="getIlac(2)">
                      <span>GENTAMİSİN</span>
                      <i class="fa fa fa-chevron-right"></i>
                    </a>
                  </li>
                  <li>
                    <a class="btn link-green" @click.prevent="getIlac(3)">
                      <span>SEFOTAKSİM</span>
                      <i class="fa fa fa-chevron-right"></i>
                    </a>
                  </li>
                  <li>
                    <a class="btn link-green" @click.prevent="getIlac(4)">
                      <span>SEFTAZİDİM</span>
                      <i class="fa fa fa-chevron-right"></i>
                    </a>
                  </li>
                  <li>
                    <a class="btn link-green" @click.prevent="getIlac(5)">
                      <span>LİNEZOLİD</span>
                      <i class="fa fa fa-chevron-right"></i>
                    </a>
                  </li>
                  <li>
                    <a class="btn link-green" @click.prevent="getIlac(6)">
                      <span>VANKOMİSİN</span>
                      <i class="fa fa fa-chevron-right"></i>
                    </a>
                  </li>
                  <li>
                    <a class="btn link-green" @click.prevent="getIlac(7)">
                      <span>MEROPENEM</span>
                      <i class="fa fa fa-chevron-right"></i>
                    </a>
                  </li>
                  <li>
                    <a class="btn link-green" @click.prevent="getIlac(8)">
                      <span>FLUKONAZOL</span>
                      <i class="fa fa fa-chevron-right"></i>
                    </a>
                  </li>
                </ul>
                <div class="ilac-detail" v-if="aktifIlac == 1">
                  <div class="ilac-header">
                    <a class="btn link-green" @click.prevent="backToIlacList()">
                      <i class="fa fa fa-chevron-left"></i>
                    </a>
                    <span>AMPİSİLİN</span>
                  </div>
                  <div class="content">
                    <table>
                      <thead>
                        <tr>
                          <th>G.Haftası</th>
                          <th>P.Natal Gün</th>
                          <th>Aralık (saat)</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>≤ 29</td>
                          <td>
                            0-28
                            <br />
                            ≥ 29
                          </td>
                          <td>
                            12
                            <br />
                            8
                          </td>
                        </tr>
                        <tr>
                          <td>30 - 36</td>
                          <td>
                            0-14
                            <br />
                            ≥ 15
                          </td>
                          <td>
                            12
                            <br />
                            8
                          </td>
                        </tr>
                        <tr>
                          <td>37 - 44</td>
                          <td>
                            0-7
                            <br />
                            ≥ 8
                          </td>
                          <td>
                            12
                            <br />
                            8
                          </td>
                        </tr>
                        <tr>
                          <td>≥ 45</td>
                          <td>Tüm</td>
                          <td>6</td>
                        </tr>
                      </tbody>
                    </table>
                    <p>
                      <b>Menenjit yoksa :</b>
                      25-50 mg/kg/doz
                    </p>
                    <p><b>Menenjit varsa;</b></p>
                    <p>
                      ≤ 7 gün : 67-100 mg/kg/doz, günde 3 doz
                    </p>
                    <p>
                      > 7 gün : 75 mg/kg/doz, günde 4 doz
                    </p>
                  </div>
                </div>
                <div class="ilac-detail" v-if="aktifIlac == 2">
                  <div class="ilac-header">
                    <a class="btn link-green" @click.prevent="backToIlacList()">
                      <i class="fa fa fa-chevron-left"></i>
                    </a>
                    <span>GENTAMİSİN</span>
                  </div>
                  <div class="content">
                    <table>
                      <thead>
                        <tr>
                          <th>G.Haftası</th>
                          <th>P.Natal Gün</th>
                          <th>Doz (mg/kg)</th>
                          <th>Aralık (saat)</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>≤ 29</td>
                          <td>
                            0-7
                            <br />
                            8-28
                            <br />
                            ≥ 29
                          </td>
                          <td>
                            5
                            <br />
                            4
                            <br />
                            4
                          </td>
                          <td>
                            48
                            <br />
                            36
                            <br />
                            24
                          </td>
                        </tr>
                        <tr>
                          <td>30-34</td>
                          <td>
                            0-7
                            <br />
                            ≥ 8
                          </td>
                          <td>
                            4.5
                            <br />
                            4
                          </td>
                          <td>
                            36
                            <br />
                            24
                          </td>
                        </tr>
                        <tr>
                          <td>≥ 35</td>
                          <td>Tüm</td>
                          <td>4</td>
                          <td>24</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div class="ilac-detail" v-if="aktifIlac == 3">
                  <div class="ilac-header">
                    <a class="btn link-green" @click.prevent="backToIlacList()">
                      <i class="fa fa fa-chevron-left"></i>
                    </a>
                    <span>SEFOTAKSİM</span>
                  </div>
                  <div class="content">
                    <table>
                      <thead>
                        <tr>
                          <th>G.Haftası</th>
                          <th>P.Natal Gün</th>
                          <th>Aralık (saat)</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>≤ 29</td>
                          <td>
                            0-28
                            <br />
                            ≥ 29
                          </td>
                          <td>
                            12
                            <br />
                            8
                          </td>
                        </tr>
                        <tr>
                          <td>30 - 36</td>
                          <td>
                            0-14
                            <br />
                            ≥ 15
                          </td>
                          <td>
                            12
                            <br />
                            8
                          </td>
                        </tr>
                        <tr>
                          <td>37 - 44</td>
                          <td>
                            0-7
                            <br />
                            ≥ 8
                          </td>
                          <td>
                            12
                            <br />
                            8
                          </td>
                        </tr>
                        <tr>
                          <td>≥ 45</td>
                          <td>Tüm</td>
                          <td>6</td>
                        </tr>
                      </tbody>
                    </table>
                    <p>
                      <b>Sepsis dozu :</b>
                      50 mg/kg/doz
                    </p>
                  </div>
                </div>
                <div class="ilac-detail" v-if="aktifIlac == 4">
                  <div class="ilac-header">
                    <a class="btn link-green" @click.prevent="backToIlacList()">
                      <i class="fa fa fa-chevron-left"></i>
                    </a>
                    <span>SEFTAZİDİM</span>
                  </div>
                  <div class="content">
                    <table>
                      <thead>
                        <tr>
                          <th>G.Haftası</th>
                          <th>P.Natal Gün</th>
                          <th>Aralık (saat)</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>≤ 29</td>
                          <td>
                            0-28
                            <br />
                            ≥ 29
                          </td>
                          <td>
                            12
                            <br />
                            8
                          </td>
                        </tr>
                        <tr>
                          <td>30 - 36</td>
                          <td>
                            0-14
                            <br />
                            ≥ 15
                          </td>
                          <td>
                            12
                            <br />
                            8
                          </td>
                        </tr>
                        <tr>
                          <td>37 - 44</td>
                          <td>
                            0-7
                            <br />
                            ≥ 8
                          </td>
                          <td>
                            12
                            <br />
                            8
                          </td>
                        </tr>
                        <tr>
                          <td>≥ 45</td>
                          <td>Tüm</td>
                          <td>6</td>
                        </tr>
                      </tbody>
                    </table>
                    <p>
                      <b>Seftazidim dozu :</b>
                      30 mg/kg/doz
                    </p>
                  </div>
                </div>
                <div class="ilac-detail" v-if="aktifIlac == 5">
                  <div class="ilac-header">
                    <a class="btn link-green" @click.prevent="backToIlacList()">
                      <i class="fa fa fa-chevron-left"></i>
                    </a>
                    <span>LİNEZOLİD</span>
                  </div>
                  <div class="content">
                    <table>
                      <thead>
                        <tr>
                          <th>Doğum Ağırlığı (kg)</th>
                          <th>P.Natal Gün</th>
                          <th>Doz (mg/kg)</th>
                          <th>Aralık (saat)</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>&lt; 1</td>
                          <td>
                            ≤ 14
                            <br />
                            15-28
                          </td>
                          <td>
                            10
                            <br />
                            10
                          </td>
                          <td>
                            12
                            <br />
                            8
                          </td>
                        </tr>
                        <tr>
                          <td>1-2</td>
                          <td>
                            ≤ 7
                            <br />
                            8-28
                          </td>
                          <td>
                            10
                            <br />
                            10
                          </td>
                          <td>
                            12
                            <br />
                            8
                          </td>
                        </tr>
                        <tr>
                          <td>&gt; 2</td>
                          <td>Tüm</td>
                          <td>10</td>
                          <td>8</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div class="ilac-detail" v-if="aktifIlac == 6">
                  <div class="ilac-header">
                    <a class="btn link-green" @click.prevent="backToIlacList()">
                      <i class="fa fa fa-chevron-left"></i>
                    </a>
                    <span>VANKOMİSİN</span>
                  </div>
                  <div class="content">
                    <table>
                      <thead>
                        <tr>
                          <th>G.Haftası</th>
                          <th>P.Natal Gün</th>
                          <th>Aralık (saat)</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>≤ 29</td>
                          <td>
                            0-28
                            <br />
                            ≥ 29
                          </td>
                          <td>
                            12
                            <br />
                            8
                          </td>
                        </tr>
                        <tr>
                          <td>30 - 36</td>
                          <td>
                            0-14
                            <br />
                            ≥ 15
                          </td>
                          <td>
                            12
                            <br />
                            8
                          </td>
                        </tr>
                        <tr>
                          <td>37 - 44</td>
                          <td>
                            0-7
                            <br />
                            ≥ 8
                          </td>
                          <td>
                            12
                            <br />
                            8
                          </td>
                        </tr>
                        <tr>
                          <td>≥ 45</td>
                          <td>Tüm</td>
                          <td>6</td>
                        </tr>
                      </tbody>
                    </table>
                    <p>
                      <b>Sepsis dozu :</b>
                      10 mg/kg/doz
                    </p>
                    <p>
                      <b>Menenjit dozu :</b>
                      15 mg/kg/doz
                    </p>
                  </div>
                </div>
                <div class="ilac-detail" v-if="aktifIlac == 7">
                  <div class="ilac-header">
                    <a class="btn link-green" @click.prevent="backToIlacList()">
                      <i class="fa fa fa-chevron-left"></i>
                    </a>
                    <span>MEROPENEM</span>
                  </div>
                  <div class="content">
                    <p><b>Sepsis</b></p>
                    <table>
                      <thead>
                        <tr>
                          <th>G.Haftası</th>
                          <th>P.Natal Gün</th>
                          <th>Doz (mg/kg)</th>
                          <th>Aralık (saat)</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>&lt; 32</td>
                          <td>
                            &lt; 14
                            <br />
                            ≥ 15
                          </td>
                          <td>
                            20
                            <br />
                            20
                          </td>
                          <td>
                            12
                            <br />
                            8
                          </td>
                        </tr>
                        <tr>
                          <td>≥ 32</td>
                          <td>
                            &lt; 14
                            <br />
                            ≥ 15
                          </td>
                          <td>
                            20
                            <br />
                            30
                          </td>
                          <td>
                            8
                            <br />
                            8
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <p><b>Menenjit</b></p>
                    <table>
                      <thead>
                        <tr>
                          <th>G.Haftası</th>
                          <th>P.Natal Gün</th>
                          <th>Aralık (saat)</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>&lt; 32</td>
                          <td>
                            &lt; 14
                            <br />
                            ≥ 15
                          </td>
                          <td>
                            12
                            <br />
                            8
                          </td>
                        </tr>
                        <tr>
                          <td>≥ 32</td>
                          <td>Tüm</td>
                          <td>8</td>
                        </tr>
                      </tbody>
                    </table>
                    <p>
                      <b>Menenjit dozu :</b>
                      40 mg/kg/doz
                    </p>
                  </div>
                </div>
                <div class="ilac-detail" v-if="aktifIlac == 8">
                  <div class="ilac-header">
                    <a class="btn link-green" @click.prevent="backToIlacList()">
                      <i class="fa fa fa-chevron-left"></i>
                    </a>
                    <span>FLUKONAZOL</span>
                  </div>
                  <div class="content">
                    <table>
                      <thead>
                        <tr>
                          <th>G.Haftası</th>
                          <th>P.Natal Gün</th>
                          <th>Aralık (saat)</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>≤ 29</td>
                          <td>
                            &lt; 14
                            <br />
                            ≥ 15
                          </td>
                          <td>
                            48
                            <br />
                            24
                          </td>
                        </tr>
                        <tr>
                          <td>≥ 30</td>
                          <td>
                            &lt; 14
                            <br />
                            ≥ 15
                          </td>
                          <td>
                            48
                            <br />
                            24
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <p>
                      <b>Tedavi dozu (Yükleme) :</b>
                      12-25 mg/kg/doz
                    </p>
                    <p>
                      <b>Tedavi dozu (İdame) :</b>
                      6-12 mg/kg/doz
                    </p>
                    <p>
                      <b>Profilaksi dozu :</b>
                      3 mg/kg/doz (Haftada 2 kez)
                    </p>
                    <p>
                      <b>Pamukçuk dozu :</b>
                      6 mg/kg PO 1 gün, idame 3 mg/kg PO
                    </p>
                  </div>
                </div>
              </transition>
            </div>
            <div class="col" v-show="isTedaviTabActive(2)">
              <ul class="sablon">
                <li class="info">
                  * Doğum tartısına (
                  <b>{{ selectedPatient[0].dtarti }} gr</b>
                  ) göre hesaplanmıştır
                </li>
                <br />
                <li class="info">
                  <span class="title">Kalsiyum 20 mg/kg</span>
                  <span class="value"> Total mayi içine {{ mayi[0] }} cc </span>
                </li>
                <li class="info">
                  <span class="title">60 cc/kg</span>
                  <span class="value">
                    {{ mayi[1] }} cc/h (TOTAL
                    {{ (mayi[1] * 24).toFixed(0) }}
                    cc)
                  </span>
                </li>
                <li class="info">
                  <span class="title">70 cc/kg</span>
                  <span class="value">
                    {{ mayi[2] }} cc/h (TOTAL
                    {{ (mayi[2] * 24).toFixed(0) }}
                    cc)
                  </span>
                </li>
                <li class="info">
                  <span class="title">80 cc/kg</span>
                  <span class="value">
                    {{ mayi[3] }} cc/h (TOTAL
                    {{ (mayi[3] * 24).toFixed(0) }}
                    cc)
                  </span>
                </li>
                <li class="info">
                  <span class="title">90 cc/kg</span>
                  <span class="value">
                    {{ mayi[4] }} cc/h (TOTAL
                    {{ (mayi[4] * 24).toFixed(0) }}
                    cc)
                  </span>
                </li>
                <li class="info">
                  <span class="title">100 cc/kg</span>
                  <span class="value">
                    {{ mayi[5] }} cc/h (TOTAL
                    {{ (mayi[5] * 24).toFixed(0) }}
                    cc)
                  </span>
                </li>
                <li class="info">
                  <span class="title">110 cc/kg</span>
                  <span class="value">
                    {{ mayi[6] }} cc/h (TOTAL
                    {{ (mayi[6] * 24).toFixed(0) }}
                    cc)
                  </span>
                </li>
                <li class="info">
                  <span class="title">120 cc/kg</span>
                  <span class="value">
                    {{ mayi[7] }} cc/h (TOTAL
                    {{ (mayi[7] * 24).toFixed(0) }}
                    cc)
                  </span>
                </li>
                <li class="info">
                  <span class="title">130 cc/kg</span>
                  <span class="value">
                    {{ mayi[8] }} cc/h (TOTAL
                    {{ (mayi[8] * 24).toFixed(0) }}
                    cc)
                  </span>
                </li>
                <li class="info">
                  <span class="title">140 cc/kg</span>
                  <span class="value">
                    {{ mayi[9] }} cc/h (TOTAL
                    {{ (mayi[9] * 24).toFixed(0) }}
                    cc)
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="card card-60" v-if="isYatis && user.level == 1">
          <p class="header" :class="modifiedDevir ? 'bg-blue' : 'bg-green'">
            Devir Notu
            <transition name="fade">
              <a
                class="header-btn btn btn-blue"
                v-show="modifiedDevir"
                @click="saveDevir()"
              >
                <i class="fa fa fa-save"></i>
                Güncelle
              </a>
            </transition>
          </p>
          <div class="modal-overlay" v-if="tedavi.mode != 0">
            <div class="modal-box small">
              <span class="close" @click="closeTedavi()">
                &times;
              </span>
              <h3>
                {{ tedavi.mode == 1 ? "Yeni Tedavi" : "Düzenle" }}
              </h3>
              <form v-on:submit.prevent>
                <div class="labeledit">
                  <label>Gün Takibi</label>
                  <div class="toggle-group">
                    <label for="p-gun-1">
                      <input
                        id="p-gun-1"
                        class="modern"
                        type="radio"
                        value="1"
                        v-model="tedavi.veri.gun"
                      />
                      <span>Evet</span>
                    </label>

                    <label for="p-gun-2">
                      <input
                        id="p-gun-2"
                        class="modern"
                        type="radio"
                        value="2"
                        v-model="tedavi.veri.gun"
                      />
                      <span>Hayır</span>
                    </label>
                  </div>
                </div>
                <div class="labeledit">
                  <label for="p-baslama">
                    Başlama Tarihi
                  </label>
                  <input
                    type="date"
                    v-model="tedavi.veri.tarih"
                    id="p-baslama"
                  />
                </div>

                <div class="labeledit">
                  <label for="p-tdv">Tedavi ve Doz</label>
                  <div class="multi-input">
                    <input
                      type="text"
                      placeholder="Tedavi"
                      v-model="tedavi.veri.tedavi"
                      id="p-tdv"
                    />
                    <div class="space"></div>
                    <input
                      type="text"
                      placeholder="Doz"
                      v-model="tedavi.veri.doz"
                      id="p-doz"
                    />
                  </div>
                </div>
              </form>
              <div class="button-bar">
                <a
                  class="btn btn-red fl"
                  v-show="tedavi.mode == 2"
                  @click.prevent="stopTedavi()"
                >
                  <i class="fa fa fa-ban"></i>
                  Stopla
                </a>
                <a class="btn link-green fr" @click.prevent="saveTedavi()">
                  <i class="fa fa fa-check"></i>
                  Kaydet
                </a>
                <div class="clear"></div>
              </div>
            </div>
          </div>
          <div class="y-devir">
            <div class="rop-alert" v-show="selectedPatient[0].dhafta < 34">
              <div class="title blink">ROP</div>
              <div class="detail">
                Bu hastanın ROP muayenesi için yakın takibi gereklidir
              </div>
            </div>
            <div class="devir-bar">
              <div class="fr">
                KŞ :
                <select
                  v-model="selectedPatient[0].ks"
                  @change="setModifiedDevir(true)"
                >
                  <option value="0">-</option>
                  <option value="1">x1</option>
                  <option value="2">x2</option>
                  <option value="4">x4</option>
                  <option value="6">x6</option>
                  <option value="8">x8</option>
                </select>
                TCB :
                <select
                  v-model="selectedPatient[0].tcb"
                  @change="setModifiedDevir(true)"
                >
                  <option value="0">-</option>
                  <option value="1">x1</option>
                  <option value="2">x2</option>
                  <option value="4">x4</option>
                  <option value="6">x6</option>
                </select>
                TARTI :
                <select
                  v-model="selectedPatient[0].tarti"
                  @change="setModifiedDevir(true)"
                >
                  <option value="1">x1</option>
                  <option value="2">x2</option>
                  <option value="3">x3</option>
                </select>
              </div>
              <div class="clear"></div>
            </div>
            <div class="content">
              <p>
                TANI :
                <b>{{ selectedPatient[0].tanilar }}</b>
              </p>
              <p>
                YATIŞININ
                <b>{{ selectedPatient[0].yatis | toGun }}Ü</b>
                ,
                <template
                  v-if="
                    selectedPatient[0].birthdate != selectedPatient[0].yatis
                  "
                ></template>
                D.YAŞI :
                <b>{{ dyas }}</b>
                , D.TARTISI :
                <b>{{ selectedPatient[0].dtarti }}</b>
                gr
              </p>
            </div>
            <div class="labeledit">
              <div class="toggle-group rbtn">
                <label for="p-solunum-1">
                  <input
                    id="p-solunum-1"
                    class="modern"
                    type="radio"
                    value="1"
                    name="solunum"
                    @input="modifiedDevir = true"
                    v-model="selectedPatient[0].takip_solunum"
                  />
                  <span>ODA HAVASI</span>
                </label>

                <label for="p-solunum-2">
                  <input
                    id="p-solunum-2"
                    class="modern"
                    type="radio"
                    value="2"
                    name="solunum"
                    @input="modifiedDevir = true"
                    v-model="selectedPatient[0].takip_solunum"
                  />
                  <span>SERBEST O2</span>
                </label>
                <label for="p-solunum-3">
                  <input
                    id="p-solunum-3"
                    class="modern"
                    type="radio"
                    value="3"
                    name="solunum"
                    @input="modifiedDevir = true"
                    v-model="selectedPatient[0].takip_solunum"
                  />
                  <span>nCPAP</span>
                </label>
                <label for="p-solunum-4">
                  <input
                    id="p-solunum-4"
                    class="modern"
                    type="radio"
                    value="4"
                    name="solunum"
                    @input="modifiedDevir = true"
                    v-model="selectedPatient[0].takip_solunum"
                  />
                  <span>ENTÜBE</span>
                </label>
              </div>
            </div>
            <div class="devir-box">
              <p>
                <b>BESLENME,TPN VE MAYİ</b>
              </p>
              <div>
                <textarea-autosize
                  spellcheck="false"
                  id="p-parenteral"
                  v-model="selectedPatient[0].takip_beslenme"
                  placeholder="Beslenme ve Tetkikler"
                  @input.native="modifiedDevir = true"
                />
              </div>
            </div>

            <div class="tedaviler">
              <div class="info-header">
                <span class="title">TEDAVİLER</span>
                <a class="btn link-green fr" @click.prevent="addTedavi()">
                  <i class="fa fa fa-plus"></i>
                  Ekle
                </a>
              </div>
              <div v-if="!selectedPatient[1].length" class="small-empty">
                <i class="fa fa-exclamation-triangle fa-3x"></i>
                <span>Henüz tedavi başlanmadı</span>
              </div>
              <ul v-if="selectedPatient[1].length">
                <li
                  v-for="t in selectedPatient[1]"
                  :key="t.id"
                  @click="editTedavi(t.id)"
                  :class="t.gun == 1 ? 'b-highligted1' : ''"
                >
                  {{ t.tedavi }}
                  {{ t.doz != "" ? "(" + t.doz + ")" : "" }}
                  <b>
                    {{ (t.gun == 1 ? t.tarih : "") | toGun }}
                  </b>
                </li>
              </ul>
            </div>
            <div class="devir-box">
              <p>
                <b>ROP, EKO VE USG TAKİPLERİ</b>
              </p>
              <div>
                <textarea-autosize
                  spellcheck="false"
                  placeholder="ROP, EKO VE USG Takipleri"
                  v-model="selectedPatient[0].plan2"
                  rows="6"
                  @input.native="modifiedDevir = true"
                />
              </div>
              <p>
                <b>TAKİPLER VE PLAN</b>
              </p>
              <div>
                <textarea-autosize
                  spellcheck="false"
                  placeholder="Takipler ve Plan"
                  v-model="selectedPatient[0].plan"
                  rows="6"
                  @input.native="modifiedDevir = true"
                />
              </div>
            </div>
          </div>
        </div>

        <div class="card">
          <div class="date-bar" :class="progress.is ? 'bg-green' : 'bg-red'">
            <a
              class="t-blue"
              v-show="!editingProgress"
              @click.prevent="navigateProgress(-1)"
            >
              <i class="fa fa-2x fa-angle-left"></i>
            </a>
            <transition name="slide-fade" mode="out-in">
              <label :key="progressDate.toString()">
                {{ progressDate | moment("DD MMMM YYYY") }}
              </label>
            </transition>
            <a
              class="t-blue"
              v-show="!editingProgress"
              @click.prevent="navigateProgress(1)"
            >
              <i class="fa fa-2x fa-angle-right"></i>
            </a>
          </div>
          <div
            class="seyir-bar"
            v-if="(progress.is || editingProgress) && isYatis"
          >
            <a
              class="btn link-purple"
              v-show="!editingProgress"
              v-clipboard:success="onCopy"
              v-clipboard:copy="
                this.$moment(progress.veri.tarih).format('DD.MM.YYYY') +
                  '\n' +
                  progress.veri.baslik +
                  '\n' +
                  progress.veri.progress
              "
            >
              <i class="fa fa fa-copy"></i>
              Kopyala
            </a>
            <a
              class="btn link-blue"
              v-show="!editingProgress && user.level == 1"
              @click="editProgress()"
            >
              <i class="fa fa fa-edit"></i>
              Düzenle
            </a>
            <a
              class="btn link-red"
              v-show="!editingProgress && user.level == 1"
              @click="deleteProgress()"
            >
              <i class="fa fa fa-trash"></i>
              Sil
            </a>
            <a
              class="btn link-green"
              v-show="editingProgress && user.level == 1"
              @click="saveProgress()"
            >
              <i class="fa fa fa-check"></i>
              Kaydet
            </a>
            <a
              class="btn link-red"
              v-show="editingProgress && user.level == 1"
              @click="cancelProgress()"
            >
              <i class="fa fa fa-times"></i>
              İptal
            </a>
          </div>
          <div class="y-progress">
            <div v-if="progress.is && !editingProgress">
              <div class="written">
                <i class="fa fa-lg fa-marker"></i>
                Dr.{{ progress.veri.asistan_name }}
              </div>
              <p class="bold">{{ progress.veri.baslik }}</p>
              <p>{{ progress.veri.progress }}</p>
            </div>
            <div v-if="!progress.is && !editingProgress" class="small-empty">
              <i class="fa fa-info-circle fa-3x"></i>
              <span>
                Bugüne ait progress yazılmamış.
                <span v-if="user.level == 1 && isYatis">
                  Yazmak için
                  <a class="c-red" @click="addProgress()">
                    tıklayın
                  </a>
                </span>
              </span>
            </div>
            <form v-on:submit.prevent v-if="editingProgress" action>
              <div class="labeledit">
                <select id="p-dr" v-model="progress.veri.asistan">
                  <option :value="0">(Yok)</option>
                  <option :value="d.id" v-for="d in activedoctors" :key="d.id">
                    Dr.{{ d.name }}
                  </option>
                </select>
              </div>
              <div class="labeledit">
                <textarea-autosize
                  spellcheck="false"
                  id="p-baslik"
                  rows="3"
                  class="bold"
                  v-model="progress.veri.baslik"
                />
              </div>
              <div class="labeledit">
                <textarea-autosize
                  spellcheck="false"
                  id="p-progress"
                  rows="9"
                  class="seyir-area"
                  v-model="progress.veri.progress"
                  placeholder="Hastanın Klinik Seyri"
                />
              </div>
            </form>
          </div>
        </div>
      </div>
      <div id="tab-2" class="tab-content" v-show="isTabActive(2)">
        <div class="card card-fw">
          <div>
            <div class="y-ozet">
              <p>
                <span class="key">
                  <span>ŞİKAYETİ</span>
                  <a
                    class="btn link-blue fr"
                    v-clipboard:copy="selectedPatient[0].tanilar"
                  >
                    <i class="fa fa fa-copy"></i>
                    Kopyala
                  </a>
                </span>
                <span class="value">
                  {{ selectedPatient[0].tanilar }}
                </span>
              </p>
              <p>
                <span class="key">
                  <span>HİKAYE</span>
                  <a
                    class="btn link-blue fr"
                    v-clipboard:copy="selectedPatient[0].oyku"
                  >
                    <i class="fa fa fa-copy"></i>
                    Kopyala
                  </a>
                </span>
                <span class="value">
                  {{ selectedPatient[0].oyku }}
                </span>
              </p>
              <p>
                <span class="key">
                  <span>ÖZGEÇMİŞ</span>
                  <a
                    class="btn link-blue fr"
                    v-clipboard:copy="selectedPatient[0].ozgecmis"
                  >
                    <i class="fa fa fa-copy"></i>
                    Kopyala
                  </a>
                </span>
                <span class="value">
                  {{ selectedPatient[0].ozgecmis }}
                </span>
                <span
                  v-show="selectedPatient[0].ozgecmis == ''"
                  class="small-empty"
                >
                  <i class="fa fa-info-circle fa-3x"></i>
                  <span>Özgeçmiş yazılmamış</span>
                </span>
              </p>
              <p>
                <span class="key">
                  <span>SOYGEÇMİŞ</span>
                  <a
                    class="btn link-blue fr"
                    v-clipboard:copy="selectedPatient[0].soygecmis"
                  >
                    <i class="fa fa fa-copy"></i>
                    Kopyala
                  </a>
                </span>
                <span class="value">
                  {{ selectedPatient[0].soygecmis }}
                </span>
                <span
                  v-show="selectedPatient[0].soygecmis == ''"
                  class="small-empty"
                >
                  <i class="fa fa-info-circle fa-3x"></i>
                  <span>Soygeçmiş yazılmamış</span>
                </span>
              </p>
              <p>
                <span class="key">
                  <span>MUAYENE</span>
                  <a
                    class="btn link-blue fr"
                    v-clipboard:copy="selectedPatient[0].muayene"
                  >
                    <i class="fa fa fa-copy"></i>
                    Kopyala
                  </a>
                </span>
                <span class="value">
                  {{ selectedPatient[0].muayene }}
                </span>
                <span
                  v-show="selectedPatient[0].muayene == ''"
                  class="small-empty"
                >
                  <i class="fa fa-info-circle fa-3x"></i>
                  <span>Muayene yazılmamış</span>
                </span>
              </p>
              <p>
                <span class="key">
                  <span>BULGULAR</span>
                  <a class="btn link-blue fr" v-clipboard:copy="epikriz_bulgu">
                    <i class="fa fa fa-copy"></i>
                    Kopyala
                  </a>
                </span>
                <span id="ozet-bulgu" class="value">
                  {{ epikriz_bulgu }}
                </span>
              </p>
              <p>
                <span class="key">
                  <span>KLİNİK SEYİR</span>
                  <a
                    class="btn link-blue fr"
                    v-clipboard:copy="epikriz_klinikseyir"
                  >
                    <i class="fa fa fa-copy"></i>
                    Kopyala
                  </a>
                </span>
                <span id="ozet-klinikseyir" class="value">
                  {{ epikriz_klinikseyir }}
                </span>
              </p>
              <p>
                <span class="key">
                  TEDAVİ VE ÖNERİLER (Şablon)
                  <a
                    class="btn link-blue fr"
                    v-clipboard:copy="selectedPatient[0].taburcu"
                  >
                    <i class="fa fa fa-copy"></i>
                    Kopyala
                  </a>
                </span>
                <span class="value">
                  {{ selectedPatient[0].taburcu }}
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>
      <div id="tab-3" class="tab-content" v-show="isTabActive(3)">
        <div id="progress-view" class="card">
          <p class="header">Progress Yazdır</p>
          <div class="topbar" v-if="selectedPatient[2].length > 0">
            <a
              class="btn link-blue"
              v-show="sprogress.length != selectedPatient[2].length"
              @click="selectProgress()"
            >
              <i class="fa fa fa-check-double"></i>
              Tüm Günleri Seç
            </a>
            <a
              class="btn link-blue"
              v-show="
                (sprogress.length == selectedPatient[2].length) &
                  (sprogress.length > 0)
              "
              @click="selectProgress()"
            >
              <i class="fa fa fa-check-double"></i>
              Tüm Günleri Seçmeyi Bırak
            </a>
            <a
              v-show="sprogress.length > 0"
              class="btn link-indigo"
              @click="printProgress()"
            >
              <i class="fa fa fa-print"></i>
              Seçili Günleri Yazdır
            </a>
          </div>
          <div class="y-page">
            <div class="page-back">
              <div id="pra-prog" class="page">
                <div
                  v-for="e in orderedSelectedProgress"
                  :key="e.id"
                  class="progress"
                  :class="e.visible ? '' : 'hidden'"
                >
                  <input type="checkbox" v-model="e.visible" />
                  <div class="left">
                    <b>
                      {{ e.tarih | moment("DD.MM.YYYY") }}
                    </b>
                    <br />
                    Dr.{{ e.asistan_name }}
                  </div>
                  <div class="right">
                    {{ selectedPatient[0].name }}
                    <br />
                    {{ e.baslik }}
                    <br />
                    {{ e.progress }}
                  </div>
                </div>
              </div>
            </div>
            <div class="list">
              <center>
                <h3>Progress Listesi</h3>
              </center>

              <div class="toggle-group vertical">
                <template v-for="e in selectedPatient[2]">
                  <label :for="'p-epi-' + e.id" :key="e.id">
                    <input
                      :id="'p-epi-' + e.id"
                      class="modern"
                      type="checkbox"
                      :value="e"
                      v-model="sprogress"
                    />
                    <span>
                      {{ e.tarih | moment("DD MMMM YYYY") }}
                    </span>
                  </label>
                </template>
                <div v-if="selectedPatient[2].length == 0" class="small-empty">
                  <i class="fa fa-info-circle fa-3x"></i>
                  <span>Henüz progress yazılmamış</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import qs from "qs";
import _ from "lodash";
import Progress from "easy-circular-progress/src/index.vue";
export default {
  name: "YogunBakim",
  components: {
    Progress,
  },
  data() {
    return {
      drag: false,
      activeTab: 1,
      aktifIlac: 0,
      births: [],
      selectedPatient: [],
      sprogress: [],
      activeTedaviTab: 1,
      editingYatis: false,
      editingNot: false,
      editingProgress: false,
      snap: "",
      snappe: "",
      progressDate: this.$moment(new Date()),
      patientsOpen: false,
      ozgecmis: {
        editing: false,
        value: "",
      },
      soygecmis: {
        editing: false,
        value: "",
      },
      muayene: {
        editing: false,
        value: "",
      },
      modifiedDevir: false,
      tedavi: {
        mode: 0,
        veri: {},
      },
      progress: {
        is: false,
        veri: {},
      },
    };
  },
  watch: {
    progressDate: {
      deep: true,
      immediate: false,
      handler: function() {
        this.progress = this.getProgress(this.progressDate);
      },
    },
  },
  computed: {
    doctors() {
      return this.$store.getters.getDoctors;
    },
    activedoctors() {
      return this.$store.getters.getActiveDoctors;
    },
    user() {
      return this.$store.getters.getUser;
    },
    sablon() {
      return this.$store.getters.getSablon;
    },
    completed() {
      var percent = 0;
      var color = "red";
      percent += this.selectedPatient[0].tanilar != "" ? 20 : 0;
      percent += this.selectedPatient[0].boy > 0 ? 10 : 0;
      percent += this.selectedPatient[0].basc > 0 ? 10 : 0;
      percent += this.selectedPatient[0].kan != "" ? 10 : 0;
      percent += this.selectedPatient[0].coombs != "" ? 10 : 0;
      percent += this.selectedPatient[0].ozgecmis != "" ? 20 : 0;
      percent += this.selectedPatient[0].soygecmis != "" ? 20 : 0;
      if (percent > 50) {
        color = "orange";
      }
      if (percent == 100) {
        color = "green";
      }
      return [percent, color];
    },
    gh() {
      return (
        this.selectedPatient[0].dhafta +
        "w" +
        (this.selectedPatient[0].dgun > 0
          ? "+" + this.selectedPatient[0].dgun + "d"
          : "")
      );
    },
    dyas() {
      var r =
        this.gunFarkiDay(this.selectedPatient[0].birthdate, new Date()) - 1;

      var h = Math.floor(r / 7);
      var g = parseInt(this.selectedPatient[0].dgun);
      var dh, dg;

      if (r - h * 7 + g < 7) {
        dh = parseInt(this.selectedPatient[0].dhafta) + h;
        dg = r - h * 7 + g;
      } else {
        dh = parseInt(this.selectedPatient[0].dhafta) + h + 1;
        dg = r - h * 7 + g - 7;
      }
      return dh + "w" + (dg > 0 ? "+" + dg + "d" : "");
    },
    solunumlar() {
      var r;
      switch (this.selectedPatient[0].takip_solunum) {
        case "1":
          r = "K.İÇİ ODA HAVASINDA TAKİPLİ";
          break;
        case "2":
          r = "K.İÇİ SERBEST O2 ALIYOR";
          break;
        case "3":
          r = "K.İÇİ NCPAP'TA TAKİPLİ";
          break;
        case "4":
          r = "K.İÇİ ENTÜBE TAKİPLİ";
          break;
      }
      return r;
    },
    tedaviler() {
      var tedaviler = "";
      var guntedaviler = "";
      let self = this;
      this.selectedPatient[1].forEach(function(arrayItem, i) {
        var isLast = self.selectedPatient[1].length - 1 == i ? true : false;
        var newLine = isLast ? "" : "\n";
        if (arrayItem.gun == 1) {
          var abgun = self.gunFarki(arrayItem.tarih, self.progressDate);
          guntedaviler +=
            arrayItem.tedavi +
            (arrayItem.doz == "" ? " " : " (" + arrayItem.doz + ") ") +
            "" +
            abgun +
            "ÜNDE ";
        } else {
          tedaviler +=
            arrayItem.tedavi +
            (arrayItem.doz == "" ? "" : " " + arrayItem.doz) +
            " ALIYOR." +
            newLine;
        }
      });
      return guntedaviler + (guntedaviler == "" ? "" : "\n") + tedaviler;
    },
    tarti_fark() {
      var r;
      if (
        parseInt(this.selectedPatient[0].dtarti) >
        parseInt(this.selectedPatient[0].ytarti)
      ) {
        r =
          " (FARK %" +
          Math.ceil(
            ((this.selectedPatient[0].dtarti - this.selectedPatient[0].ytarti) /
              this.selectedPatient[0].dtarti) *
              1000
          ) /
            10 +
          ")";
      } else {
        r = "";
      }
      return r;
    },
    selectedPatientID() {
      if (this.selectedPatient.length) {
        return this.selectedPatient[0].id;
      } else {
        return -1;
      }
    },
    isYatis() {
      if (this.selectedPatient.length) {
        var r;
        switch (this.selectedPatient[0].isyatis) {
          case "1":
            r = true;
            break;

          case "0":
            r = false;
            break;
        }
        return r;
      } else {
        return -1;
      }
    },
    yatirandr_name() {
      if (this.selectedPatientID > -1) {
        return this.$store.getters.getDRName(this.selectedPatient[0].dr);
      } else {
        return "";
      }
    },
    epikriz_bulgu() {
      if (this.selectedPatientID > -1) {
        var dt = "DOĞUM TARTISI : " + this.selectedPatient[0].dtarti + " GR \n";
        var yt = "YATIŞ TARTISI : " + this.selectedPatient[0].ytarti + " GR \n";
        var boy =
          this.selectedPatient[0].boy > 0
            ? "BOY : " + this.selectedPatient[0].boy + " CM\n"
            : "";
        var basc =
          this.selectedPatient[0].basc > 0
            ? "BAŞ ÇEVRESİ : " + this.selectedPatient[0].basc + " CM"
            : "";
        return dt + yt + boy + basc;
      } else {
        return "";
      }
    },
    epikriz_klinikseyir() {
      if (this.selectedPatientID > -1) {
        var r;
        r =
          this.$moment(this.selectedPatient[0].yatis).format("DD.MM.YYYY") +
          "\n";
        r += "YATIŞ NOTU" + "\n";
        r += this.selectedPatient[0].oyku + "\n" + "\n";
        r += this.selectedPatient[0].ynot + "\n" + "\n";
        r += this.selectedPatient[0].snap + "\n" + "\n";
        this.orderedProgresses.forEach((item) => {
          r += this.$moment(item.tarih).format("DD.MM.YYYY") + "\n";
          r += item.baslik + "\n";
          r += item.progress + "\n" + "\n";
        });
        return r;
      } else {
        return "";
      }
    },
    mayi() {
      var kg = Number(this.selectedPatient[0].dtarti / 1000);
      return [
        ((kg * 20) / 9.3).toFixed(1),
        ((kg * 60) / 24).toFixed(1),
        ((kg * 70) / 24).toFixed(1),
        ((kg * 80) / 24).toFixed(1),
        ((kg * 90) / 24).toFixed(1),
        ((kg * 100) / 24).toFixed(1),
        ((kg * 110) / 24).toFixed(1),
        ((kg * 120) / 24).toFixed(1),
        ((kg * 130) / 24).toFixed(1),
        ((kg * 140) / 24).toFixed(1),
      ];
    },

    orderedProgresses: function() {
      return _.orderBy(this.selectedPatient[2], "tarih");
    },
    orderedSelectedProgress: function() {
      return _.orderBy(this.sprogress, "tarih");
    },
    dragOptions() {
      return {
        animation: 0,
        group: "description",
        disabled: false,
        ghostClass: "ghost",
        delay: 1000, // time in milliseconds to define when the sorting should start
        delayOnTouchOnly: true,
      };
    },
  },
  methods: {
    // Tabs
    isTabActive(menuItem) {
      return this.activeTab === menuItem;
    },
    setTabActive(menuItem) {
      this.activeTab = menuItem;
    },
    // İlaçlar
    backToIlacList() {
      this.aktifIlac = 0;
    },
    getIlac(ilac) {
      this.aktifIlac = ilac;
    },
    setModifiedDevir(m) {
      this.modifiedDevir = m;
    },

    // Skorlama
    skorla() {
      var r;

      var s = this.snap;
      var s2 = this.snappe;
      var o1, o2, o3, o4, o5, o6;
      if (s != "" && s2 != "") {
        switch (true) {
          case s2 >= 0 && s2 <= 9:
            o1 = 0.3;
            o2 = 0.3;
            o3 = 0.6;
            o4 = 0.5;
            o5 = 0.3;
            o6 = 0.3;
            break;
          case s2 >= 10 && s2 <= 19:
            o1 = 1.6;
            o2 = 1.6;
            o3 = 2.7;
            o4 = 2.2;
            o5 = 1.1;
            o6 = 1.3;
            break;
          case s2 >= 20 && s2 <= 29:
            o1 = 3.8;
            o2 = 3.6;
            o3 = 5.2;
            o4 = 4.9;
            o5 = 2.9;
            o6 = 2.8;
            break;
          case s2 >= 30 && s2 <= 39:
            o1 = 7.4;
            o2 = 8.0;
            o3 = 9.5;
            o4 = 9.3;
            o5 = 5.2;
            o6 = 6.5;
            break;
          case s2 >= 40 && s2 <= 49:
            o1 = 15.7;
            o2 = 14.7;
            o3 = 15.9;
            o4 = 15.7;
            o5 = 15.4;
            o6 = 13.0;
            break;
          case s2 >= 50 && s2 <= 59:
            o1 = 22.1;
            o2 = 21.4;
            o3 = 22.6;
            o4 = 22.6;
            o5 = 20.9;
            o6 = 19.0;
            break;
          case s2 >= 60 && s2 <= 69:
            o1 = 32.6;
            o2 = 32.3;
            o3 = 32.7;
            o4 = 32.3;
            o5 = 32.0;
            o6 = 32.0;
            break;
          case s2 >= 70 && s2 <= 79:
            o1 = 38.7;
            o2 = 44.4;
            o3 = 38.0;
            o4 = 43.8;
            o5 = 42.9;
            o6 = 47.6;
            break;
          case s2 >= 80:
            o1 = 66.7;
            o2 = 63.8;
            o3 = 66.7;
            o4 = 64.4;
            o5 = 66.7;
            o6 = 55.6;
            break;
          default:
            o1 = 0.3;
            o2 = 0.3;
            o3 = 0.6;
            o4 = 0.5;
            o5 = 0.3;
            o6 = 0.3;
            break;
        }
        r =
          "HASTANIN SNAP 2 SKORU " +
          s +
          ", SNAP-PE 2 SKORU " +
          s2 +
          " OLARAK HESAPLANDI.\n\nSNAP-PE 2 SKORUNA GÖRE TÜM DOĞUM AĞIRLIKLARI İÇİN GÖZLENEN ÖLÜM ORANI %" +
          o1 +
          ", BEKLENEN ÖLÜM ORANI %" +
          o2 +
          " OLARAK HESAPLANDI.\nSNAP-PE 2 SKORUNA GÖRE KENDİ DOĞUM AĞIRLIKLARI İÇİN GÖZLENEN ÖLÜM ORANI %" +
          (this.selectedPatient[0].dtarti < 1500 ? o3 : o5) +
          " BEKLENEN ÖLÜM ORANI % " +
          (this.selectedPatient[0].dtarti < 1500 ? o4 : o6) +
          " OLARAK HESAPLANDI.";

        this.selectedPatient[0].snap = r;
        this.saveNot();
      } else {
        this.$snotify.error("SNAP skoru yazılmamış");
      }
    },
    // Hasta Listesi

    patient_status(p) {
      var r = "";
      switch (parseInt(p)) {
        case 1:
          r = "finished";
          break;
        case 0:
          r = "unfinished";
          break;
        case -1:
          r = "taburcu";
          break;
      }
      return r;
    },
    coombs_color() {
      var r = "";
      switch (this.selectedPatient[0].coombs) {
        case "D.Coombs (-)":
          r = "c-green";
          break;
        default:
          r = "c-red";
          break;
      }
      return r;
    },
    getPatient(p, onlyRefresh = true) {
      if (p > -1) {
        let self = this;
        this.$http
          .get("api/yenidogan/get-patient.php", {
            params: {
              id: p,
            },
          })
          .then(function(response) {
            response.data.data.progress.forEach((p) => (p.visible = true));
            self.selectedPatient = Array(
              response.data.data.patient,
              response.data.data.tedavi,
              response.data.data.progress
            );
            self.patientsOpen = false;
            if (!onlyRefresh) {
              self.progressDate = self.$moment(new Date());
            } else {
              self.progress = self.getProgress(self.progressDate);
            }
            self.editingProgress = false;
            self.editingYatis = false;
            self.editingNot = false;
            self.tedavi.mode = 0;
            self.snap = "";
            self.snappe = "";
            self.backToIlacList();
            self.sprogress = [];
          });
      } else {
        this.selectedPatient = [];
      }
    },
    getList() {
      this.$socket.client.emit("update", "patients");
      this.$store.dispatch("fillPatients");
    },
    // Yatış Bilgileri
    taburcu() {
      if (confirm("Hasta taburcu edilecek. Devam etmek istiyor musunuz?")) {
        this.selectedPatient[0].isyatis = 0;
        this.selectedPatient[0].taburcudate = this.$moment(new Date()).format(
          "YYYY-MM-DD"
        );
        this.saveisYatis();
      }
    },
    undotaburcu() {
      if (
        confirm(
          "Hasta tekrardan listeye eklenecek. Devam etmek istiyor musunuz?"
        )
      ) {
        this.selectedPatient[0].isyatis = 1;
        this.selectedPatient[0].taburcudate = "";
        this.saveisYatis();
      }
    },
    removePatient() {
      if (confirm("Hasta sistemden silinecek. Devam etmek istiyor musunuz?")) {
        this.$http({
          method: "post",
          url: "api/yenidogan/edit-patient.php",
          data: qs.stringify({
            id: this.selectedPatient[0].id,
            q: "remove",
          }),
        }).then(() => {
          this.$snotify.success("Hasta sistemden silindi");
          this.$router.push("/yenidogan");
        });
      }
    },
    editYatis() {
      this.editingYatis = true;
    },
    cancelYatis() {
      this.editingYatis = false;
      this.getPatient(this.selectedPatientID);
    },
    saveisYatis() {
      this.$http({
        method: "post",
        url: "api/yenidogan/edit-patient.php",
        data: qs.stringify({
          id: this.selectedPatient[0].id,
          isyatis: this.selectedPatient[0].isyatis,
          taburcudate: this.selectedPatient[0].taburcudate,
          q: "isyatis",
        }),
      }).then(() => {
        this.$snotify.success("Yatış durumu güncellendi");
        this.$router.push("/patients/yogunbakim");
        this.getList();
      });
    },
    saveYatis() {
      var veri = JSON.parse(JSON.stringify(this.selectedPatient[0]));
      veri.q = "yatis";
      this.$http({
        method: "post",
        url: "api/yenidogan/edit-patient.php",
        data: qs.stringify(veri),
      }).then(() => {
        this.$snotify.success("Yatış bilgileri güncellendi");
        this.getList();
        this.getPatient(this.selectedPatientID);
      });
    },
    // Ozgecmis ve Soygecmis
    editOzgecmis(type) {
      this.ozgecmis.editing = true;
      this.ozgecmis.value = JSON.parse(
        JSON.stringify(this.selectedPatient[0].ozgecmis)
      );
      if (type == "sablon") {
        this.ozgecmis.value = this.sablon.ydozgecmis;
      }
    },
    saveOzgecmis() {
      this.$http({
        method: "post",
        url: "api/yenidogan/edit-patient.php",
        data: qs.stringify({
          id: this.selectedPatient[0].id,
          ozgecmis: this.ozgecmis.value,
          q: "ozgecmis",
        }),
      }).then(() => {
        this.$snotify.success("Özgeçmiş güncellendi");
        this.selectedPatient[0].ozgecmis = this.ozgecmis.value;
        this.ozgecmis.editing = false;
      });
    },
    editSoygecmis(type) {
      this.soygecmis.editing = true;
      this.soygecmis.value = JSON.parse(
        JSON.stringify(this.selectedPatient[0].soygecmis)
      );
      if (type == "sablon") {
        this.soygecmis.value = this.sablon.ydsoygecmis;
      }
    },
    saveSoygecmis() {
      this.$http({
        method: "post",
        url: "api/yenidogan/edit-patient.php",
        data: qs.stringify({
          id: this.selectedPatient[0].id,
          soygecmis: this.soygecmis.value,
          q: "soygecmis",
        }),
      }).then(() => {
        this.$snotify.success("Soygeçmiş güncellendi");
        this.selectedPatient[0].soygecmis = this.soygecmis.value;
        this.soygecmis.editing = false;
      });
    },
    editMuayene(type) {
      this.muayene.editing = true;
      this.muayene.value = JSON.parse(
        JSON.stringify(this.selectedPatient[0].muayene)
      );
      if (type == "sablon") {
        this.muayene.value = this.sablon.ydmuayene;
      }
    },
    saveMuayene() {
      this.$http({
        method: "post",
        url: "api/yenidogan/edit-patient.php",
        data: qs.stringify({
          id: this.selectedPatient[0].id,
          muayene: this.muayene.value,
          q: "muayene",
        }),
      }).then(() => {
        this.$snotify.success("Muayene güncellendi");
        this.selectedPatient[0].muayene = this.muayene.value;
        this.muayene.editing = false;
      });
    },
    // Tedavi Tabs
    isTedaviTabActive(menuItem) {
      return this.activeTedaviTab === menuItem;
    },
    setTedaviTabActive(menuItem) {
      this.activeTedaviTab = menuItem;
    },
    // Tedaviler
    closeTedavi() {
      this.tedavi.mode = 0;
      this.getPatient(this.selectedPatientID);
    },
    addTedavi() {
      this.tedavi.mode = 1;
      this.tedavi.veri = {
        q: "add",
        gun: 2,
        tedavi: "",
        doz: "",
        hasta: this.selectedPatientID,
        tarih: this.$moment(new Date()).format("YYYY-MM-DD"),
      };
    },
    editTedavi(id) {
      this.tedavi.mode = 2;
      this.tedavi.veri = this.selectedPatient[1].find((t) => t.id === id);
      this.tedavi.veri.q = "edit";
    },
    stopTedavi() {
      let self = this;
      this.$http({
        method: "post",
        url: "api/yenidogan/tedavi.php",
        data: qs.stringify({
          id: this.tedavi.veri.id,
          q: "stop",
        }),
      }).then(() => {
        self.$snotify.success("Tedavi stoplandı");
        self.tedavi.mode = 0;
        self.getPatient(this.selectedPatientID);
      });
    },
    saveTedavi() {
      this.$http({
        method: "post",
        url: "api/yenidogan/tedavi.php",
        data: qs.stringify(this.tedavi.veri),
      }).then(() => {
        this.$snotify.success("Tedavi kaydedildi");
        this.tedavi.mode = 0;
        this.getPatient(this.selectedPatientID);
      });
    },
    // Devir Notu
    saveDevir() {
      var veri = JSON.parse(JSON.stringify(this.selectedPatient[0]));
      veri.q = "devir";
      this.$http({
        method: "post",
        url: "api/yenidogan/edit-patient.php",
        data: qs.stringify(veri),
      }).then(() => {
        this.$snotify.success("Devir Notu güncellendi");
        this.getPatient(this.selectedPatientID);
        this.modifiedDevir = false;
        this.getList();
      });
    },
    // Progress
    getProgress(d) {
      var r;
      r = {
        veri: this.selectedPatient[2].find(
          (t) =>
            t.tarih ===
            this.$moment(d)
              .format("YYYY-MM-DD")
              .toString()
        ),
      };
      if (r.veri == undefined) {
        r.is = false;
      } else {
        r.is = true;
      }
      return r;
    },
    navigateProgress(step) {
      if (
        this.$moment(
          this.$moment(this.progressDate).add(step, "days")
        ).isBetween(this.selectedPatient[0].yatis, new Date())
      ) {
        this.progressDate = this.$moment(this.progressDate).add(step, "days");
      }
    },
    editProgress() {
      this.editingProgress = true;
      this.progress.veri.q = "edit";
    },
    gunFarki(b1, b2) {
      var days = this.$moment(b2).diff(this.$moment(b1), "days", true);
      return Math.ceil(days) + ".GÜN";
    },
    gunFarkiDay(b1, b2) {
      var days = this.$moment(b2).diff(this.$moment(b1), "days", true);
      return Math.ceil(days);
    },
    saatFarki(b1) {
      var hours = this.$moment().diff(this.$moment(b1), "hours", true);
      return Math.ceil(hours);
    },
    addProgress() {
      // Sablon oluştur
      var yatisgun = this.gunFarki(
        this.selectedPatient[0].yatis,
        this.progressDate
      );

      // Tedavi Şablonu
      var tdvsablon = this.tedaviler;

      // D.Yası
      var r =
        this.gunFarkiDay(this.selectedPatient[0].birthdate, this.progressDate) -
        1;

      var h = Math.floor(r / 7);
      var g = parseInt(this.selectedPatient[0].dgun);
      var dh, dg;

      if (r - h * 7 + g < 7) {
        dh = parseInt(this.selectedPatient[0].dhafta) + h;
        dg = r - h * 7 + g;
      } else {
        dh = parseInt(this.selectedPatient[0].dhafta) + h + 1;
        dg = r - h * 7 + g - 7;
      }
      var dyas = dh + "w" + (dg > 0 ? "+" + dg + "d" : "");

      // Önceki progress
      var prev = this.getProgress(
        this.$moment(this.progressDate).add(-1, "days")
      );
      var previous;
      if (prev.is) {
        previous = prev.veri.progress;
      } else {
        previous = "";
      }
      var sablon =
        this.selectedPatient[0].tanilar +
        "\n" +
        "YATIŞININ " +
        yatisgun +
        "Ü " +
        "D.YAŞI : " +
        dyas +
        "\n" +
        this.solunumlar +
        "\n" +
        this.selectedPatient[0].takip_beslenme +
        (tdvsablon != "" ? "\n" : "") +
        tdvsablon;
      this.editingProgress = true;
      this.progress.veri = {
        q: "add",
        baslik: sablon,
        progress: previous,
        hasta: this.selectedPatientID,
        tarih: this.$moment(this.progressDate).format("YYYY-MM-DD"),
        asistan_name: this.user.name,
        asistan: this.user.id,
      };
    },
    saveProgress() {
      this.$http({
        method: "post",
        url: "api/yenidogan/progress.php",
        data: qs.stringify(this.progress.veri),
      }).then(() => {
        this.$snotify.success("Klinik Seyir kaydedildi");
        this.getList();
        this.getPatient(this.selectedPatientID);
      });
    },
    deleteProgress() {
      if (confirm("Seçili progress silinecek. Devam etmek istiyor musunuz?")) {
        this.$http({
          method: "post",
          url: "api/yenidogan/progress.php",
          data: qs.stringify({
            id: this.progress.veri.id,
            q: "delete",
          }),
        }).then(() => {
          this.$snotify.success("Klinik Seyir silindi");
          this.getList();
          this.getPatient(this.selectedPatientID);
        });
      }
    },
    cancelProgress() {
      this.editingProgress = false;
      this.getPatient(this.selectedPatientID);
    },
    // Yatış Notu
    editNot() {
      this.editingNot = true;
    },
    saveNot() {
      var veri = JSON.parse(JSON.stringify(this.selectedPatient[0]));
      veri.q = "not";
      this.$http({
        method: "post",
        url: "api/yenidogan/edit-patient.php",
        data: qs.stringify(veri),
      }).then(() => {
        this.$snotify.success("Yatış Notu güncellendi");
        this.getPatient(this.selectedPatientID);
      });
    },
    cancelNot() {
      this.editingNot = false;
      this.getPatient(this.selectedPatientID);
    },
    printYatisNotu() {
      const options = {
        name: "_blank",
        specs: ["height=800", "height=800", "titlebar=yes", "scrollbars=yes"],
        styles: ["https://pediatrim.net/print/yatis.css"],
      };
      this.$htmlToPaper("printYatisNotu", options);
    },
    // Epikriz
    onCopy() {
      this.$snotify.info("Klinik Seyir kopyalandı");
    },
    // Progress Listesi
    selectProgress() {
      if (this.sprogress.length == this.selectedPatient[2].length) {
        this.sprogress = [];
      } else {
        this.sprogress = [];
        this.selectedPatient[2].forEach((element) => {
          this.sprogress.push(element);
        });
      }
    },
    printProgress() {
      const options = {
        name: "_blank",
        specs: ["height=800", "height=800", "titlebar=yes", "scrollbars=yes"],
        styles: ["https://pediatrim.net/print/progress.css"],
      };
      this.$htmlToPaper("pra-prog", options);
    },
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      var v = to.params.id != undefined ? to.params.id : -1;
      vm.getPatient(v, false);
      // vm.getList();
    });
  },
  beforeRouteUpdate(to, from, next) {
    var v = to.params.id != undefined ? to.params.id : -1;
    this.getPatient(v, false);
    //this.getList();
    next();
  },
};
</script>

<style lang="scss">
// Animation
.flip-list-move {
  transition: transform 0.5s;
}
.no-move {
  transition: transform 0s;
}
.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}

div.ozet {
  display: flex;
  flex-wrap: wrap;
  padding: 5px;
  margin: 0;
  background-color: lighten($orange, 20);
  div {
    flex: 1 1 50%;
    line-height: 20px;
    text-align: center;
    span.adet {
      display: block;
      font-size: 16px;
      font-weight: 700;
      width: 35px;
      color: white;
      padding: 5px 10px;
      text-align: center;
      margin: 0 auto;
    }
  }
}
</style>
